import { plainToInstance } from 'class-transformer'

import { BaseFlowButtonWithOutput } from '../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/Buttons/FlowButtons/BaseFlowButtonWithOutput'
import { SocketNames, SocketsActionsTypes } from '../../../../../../components'
import { BaseNodeModelData,
  IBaseData
} from "../../../../BaseNode/BaseNodeDataModel";
import { NodeTypes } from '../../../../index'
import { SendMessageNodeData } from '../SendMessageNode'
import SendMessageAction from '../actions/SendMessageAction'
import TypingAction from '../actions/TypingAction'
import UserInputAction from '../actions/UserInputAction'
import { MessageNodeActionTypes, SendMessageNodeProps } from '../types'
import ProxySendMessageAction from './actions/ProxySendMessageAction'
import ProxySendMessageNodeAction from './actions/ProxySendMessageNodeAction'
import ProxyTypingAction from './actions/ProxyTypingAction'
import ProxyUserInputAction from './actions/ProxyUserInputAction'

export default class ProxySendMessageData implements IBaseData {
  type: NodeTypes.SendMessage = NodeTypes.SendMessage

  proxyActions: Array<ProxySendMessageNodeAction> = []

  inactive_action: { output: number, time: number }

  private readonly socketsActions: SocketsActionsTypes | null = null

  constructor(data: SendMessageNodeData, socketsActions: SocketsActionsTypes, nodeProps: SendMessageNodeProps) {
    this.socketsActions = socketsActions

    socketsActions.createOutput(data.inactive_action.output, SocketNames.Inactive)

    this.inactive_action = data.inactive_action

    data.actions.forEach((a) => {
      if (a instanceof SendMessageAction) {
        this.proxyActions.push(new ProxySendMessageAction(a, socketsActions))
      }

      if (a instanceof TypingAction) {
        this.proxyActions.push(new ProxyTypingAction(a))
      }

      if (a instanceof UserInputAction) {
        this.proxyActions.push(new ProxyUserInputAction(a, socketsActions, nodeProps))
      }
    })
  }

  getData(): BaseNodeModelData {
    return plainToInstance(SendMessageNodeData, {
      type: NodeTypes.SendMessage,
      inactive_action: this.inactive_action,
      actions: this.proxyActions.map((a) => a.getModel())
    })
  }

  get buttonsExist(): boolean {
    return this.proxyActions.some((a) => {
      if (a instanceof ProxySendMessageAction && a.action.variants.length) {
        return !!a.action.variants[0].buttons.length
      }
    })
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  removeAction(proxyAction: ProxySendMessageNodeAction): void {
    if (proxyAction instanceof ProxySendMessageAction && proxyAction.action.variants.length && proxyAction.action.variants[0].buttons.length) {
      proxyAction.action.variants[0].buttons.forEach((r) => r.forEach((b) => {
        if (b instanceof BaseFlowButtonWithOutput && b.output && this.socketsActions) {

          this.socketsActions.switchIsMoved(b.output, false)

          setTimeout(() => {
            if (this.socketsActions && b.output) {
              this.socketsActions.deleteOutput(b.output)
            }
          })
        }
      }))
    }

    const index = this.proxyActions.indexOf(proxyAction)

    if (this.proxyActions[index - 1] instanceof ProxyTypingAction) {
      this.proxyActions.splice(index - 1, 2)
    } else {
      this.proxyActions.splice(this.proxyActions.indexOf(proxyAction), 1)
    }
  }

  switchTyping(index: number): void {
    const action = this.proxyActions[index - 1]

    if (action instanceof ProxyTypingAction) {
      this.proxyActions.splice(index - 1, 1)
    } else {
      this.proxyActions.splice(index, 0, new ProxyTypingAction({ time: 1, type: MessageNodeActionTypes.Typing }))
    }
  }

  setInactiveTime(time: number): void {
    this.inactive_action.time = time
  }
}
